module.exports = __webpack_public_path__ + "img/backup-archive.079b6e08.png";